import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import SidebarTopbar from "./layout";
import LeftSection from "./leftSection";
import AssetsGeneration from "../pubvision/AssetsGeneration";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const PublicationView = () => {
  const { id: publicationId } = useParams();
  const [publicationData, setPublicationData] = useState(null);
  const [loadingPublication, setLoadingPublication] = useState(true);
  const [refreshTrigger, setRefreshTrigger] = useState(0);

  useEffect(() => {
    const fetchPublication = async () => {
      const token = localStorage.getItem("authToken");
      if (!token) {
        setLoadingPublication(false);
        return;
      }
      setLoadingPublication(true);
      try {
        const response = await fetch(`${BASE_URL}/getPublicationsWithFilesAndTasks?publicationId=${publicationId}`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          console.error("Failed to fetch publication data");
          return;
        }

        const data = await response.json();
        const publication = data.find((pub) => pub.id === Number(publicationId));
        setPublicationData(prev => {
          const newPublication = publication || null;
          if (JSON.stringify(prev) === JSON.stringify(newPublication)) {
            return prev;
          }
          return newPublication;
        });
      } catch (error) {
        console.error("Error fetching publication:", error);
      } finally {
        setLoadingPublication(false);
      }
    };

    if (publicationId) {
      fetchPublication();
    }
  }, [publicationId, refreshTrigger]);

  return (
    <SidebarTopbar>
      <div style={{ display: "flex", flex: 1, gap: "20px", height: "calc(100vh - 124px)", overflow: "hidden" }}>
        <LeftSection 
          publicationId={publicationId} 
          publicationData={publicationData} 
          loadingPublication={loadingPublication} 
        />
        <AssetsGeneration 
          publicationData={publicationData} 
          refreshTrigger={refreshTrigger}
          setRefreshTrigger={setRefreshTrigger} 
        />
      </div>
    </SidebarTopbar>
  );
};

export default PublicationView;